var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnderRepairIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 4,
    fill: "#8A38F5",
    fillOpacity: 0.08
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_21",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 26,
    height: 26
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 26,
    height: 26,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_21)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.3167 28.75L23.225 23.6583C22.4847 24.2361 21.6677 24.6875 20.774 25.0125C19.8802 25.3375 18.9278 25.5 17.9167 25.5C16.2917 25.5 14.8246 25.1028 13.5156 24.3083C12.2066 23.5139 11.1729 22.4667 10.4146 21.1667H13.0687C13.6826 21.8347 14.4003 22.3628 15.2219 22.751C16.0434 23.1392 16.9417 23.3333 17.9167 23.3333C19.7222 23.3333 21.2569 22.7014 22.5208 21.4375C23.7847 20.1736 24.4167 18.6389 24.4167 16.8333C24.4167 15.0278 23.7847 13.4931 22.5208 12.2292C21.2569 10.9653 19.7222 10.3333 17.9167 10.3333C16.2194 10.3333 14.7524 10.9066 13.5156 12.0531C12.2788 13.1997 11.5882 14.6125 11.4437 16.2917H9.27708C9.42153 13.9986 10.3198 12.0712 11.9719 10.5094C13.624 8.94757 15.6056 8.16667 17.9167 8.16667C20.3361 8.16667 22.3854 9.00625 24.0646 10.6854C25.7437 12.3646 26.5833 14.4139 26.5833 16.8333C26.5833 17.8444 26.4208 18.7969 26.0958 19.6906C25.7708 20.5844 25.3194 21.4014 24.7417 22.1417L29.8333 27.2333L28.3167 28.75ZM16.7521 21.1667L15.0458 15.5333L13.6375 19.5417H8.16666V17.9167H12.5L14.2875 12.7708H15.9125L17.5646 18.2958L18.7292 14.6667H20.3542L21.9792 17.9167H22.7917V19.5417H20.9771L19.7042 16.9958L18.35 21.1667H16.7521Z",
    fill: "#8A38F5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderRepairIcon);
export default __webpack_public_path__ + "static/media/under-repair-icon.d728ef4f7ac9b3b5097e6fb4776330fe.svg";
export { ForwardRef as ReactComponent };